import React from 'react';

export default function HTML_Lists() {
  return (
    <div className="HTML_Lists">
      <h1>HTML Lists</h1>
      <p>This is the placeholder component for <strong>HTML Lists</strong>.</p>
      <p>Link: /html/lists</p>
    </div>
  );
}
